import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { AppVersionModel } from "common/models/page-models/App Version Model/app-version-form-model";
import { AppModel } from "common/models/page-models/App_Model/app-form.model";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { FormDataService } from "../Intership-List/intership-filter-form-data.service";
import { editInfo } from "common/models/utility-models/utility-interface";
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AppDataService extends FormDataService<AppModel> {

    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.appStateInfo, http, ss);
    }


    override getEditUrlAndMethod(id: any): editInfo {
        throw new Error("Method not implemented.");
    }


    createInstance(): AppVersionModel {
        return new AppVersionModel();
    }

    getDataOfAppState(): Promise<any> {
        return new Promise((resolve, reject) => {
          this.apiService
            .postData(environment.apiUrl + API_URL.appStateInfo, {})
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      }


}
